import { faPencil, faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Link, UserProfileImage } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useSelector from '@hooks/useSelector'
import useSubscriber from '@hooks/useSubscriber'
import useSubscribers from '@hooks/useSubscribers'

import type { ConversationModel } from '@models/types'

interface SubscribersProps {
  conversation: ConversationModel,
}

const Subscribers = (props: SubscribersProps) => {
  const { conversation } = props

  const subscribersPayload = useSubscribers({
    filters: {
      subscribable_id: conversation.id,
      subscribable_type: 'Conversation',
    },
  })

  const { filteredSubscribers } = subscribersPayload

  const { images, users } = useSelector(reduxState => reduxState.entities)

  const {
    callbacks: {
      manageSubscribersModal,
    },
  } = useSubscriber(filteredSubscribers[0])

  return (
    <Box alignItems="center" flexShrink={2} justifyContent="flex-end">
      {conversation.id && filteredSubscribers.map((subscriber) => {
        const user = users[subscriber.user_id]
        // @ts-expect-error TS2538
        const image = images[user?.image_id]
        const imageUrl = digObject(image, 'thumb_url', '')

        return (
          <UserProfileImage
            boxProps={{
              backgroundSize: 'contain', borderRadius: 50, marginLeft: '2px', width: 30,
            }}
            imageUrl={imageUrl}
          >
            <FontAwesomeIcon icon={faUser} />
          </UserProfileImage>
        )
      })}

      <Link textProps={{ marginLeft: 'medium' }} onClick={() => manageSubscribersModal()} greyLink>
        <FontAwesomeIcon icon={faPencil} />
      </Link>
    </Box>
  )
}

export default Subscribers
